import React, { Component } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { analyticeEvent } from "utils/Utils"

@observer
class SalesDefaultLeftView extends Component {
    render() {
        const { rootStore } = this.props;
        const settingStore = rootStore.settingStore;
        settingStore.setSettingUseMenu("use");
        settingStore.setSettingView(false);
        const fn_setting_default_menu = (menu) => {
            settingStore.setSettingSalesMenu(menu);
        }
        return (
            <div className="sales_menu">
                <ul id="leftMenu">
                    <label>
                        <li className={settingStore.getSettingSalesMenu === 'salesList' ? 'on sales' : 'sales'}
                            onClick={event => {
                                fn_setting_default_menu('salesList')
                                analyticeEvent("salesAnalysisTab", "salesAnalysisProduct Button", rootStore.searchStore.getShopCd) //GA4
                            }}>
                            <Link to={"/setting/sales/product"}>판매상품</Link>
                        </li>
                        <li className={settingStore.getSettingSalesMenu === 'timeList' ? 'on time' : 'time'}
                            onClick={event => {
                                fn_setting_default_menu('timeList')
                                analyticeEvent("salesAnalysisTab", "salesAnalysisTime Button", rootStore.searchStore.getShopCd) //GA4
                            }}>
                            <Link to={"/setting/sales/Time"}>시간대</Link>
                        </li>
                        {/* <li className={settingStore.getSettingUseMenu === 'use' ? 'on' : ''}>
                            <Link to={"/setting/sales/calendar"}>일자별</Link>
                        </li> */}
                    </label>
                </ul>
            </div>
        )
    }
}

export default SalesDefaultLeftView;